<div class="goa-callout goa--{{ type }}">
  <h3 *ngIf="heading">{{ heading }}</h3>
  <ng-content></ng-content>
</div>
